module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title-button"
  }, [_vm._v("\n    " + _vm._s(_vm.step.title) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-758e3b35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/controls/FileUpload.vue
// module id = 2609
// module chunks = 1